import React, { lazy, Suspense, useState, useEffect, useRef } from "react";
import { Box, CircularProgress, Fade } from "@mui/material";
import Navbar from "../../widgets/navbar/navbar";
import MenuDrawer from "../../../../Components/Widgets/MenuDrawer";
import SubMenuDrawer from "../../../../Components/Widgets/SubMenuDrawer";
import Footer from "../../widgets/footer";

const HomeHeroSlide = lazy(
  () => import("../../../default/widgets/sliders/home-hero-slide"),
);

const Legacy = lazy(() => import("../../../default/widgets/legacy/legacy"));

const ExportDefault = (props) => {
  const [visibleSections, setVisibleSections] = useState({
    about: false,
  });

  const sectionRefs = useRef({
    legacy: null,
  });

  useEffect(() => {
    const observerOptions = {
      root: null,
      rootMargin: "0px 0px 500px 0px", // Start loading 500px before entering the viewport
      threshold: 0.01,
    };

    const observerCallback = (entries, observer) => {
      let newVisibleSections = {};
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const sectionId = entry.target.id;
          newVisibleSections[sectionId] = true;
          observer.unobserve(entry.target);
        }
      });

      // Batch updates
      if (Object.keys(newVisibleSections).length) {
        setVisibleSections((prev) => ({ ...prev, ...newVisibleSections }));
      }
    };

    const observer = new IntersectionObserver(
      observerCallback,
      observerOptions,
    );

    Object.values(sectionRefs.current).forEach((ref) => {
      if (ref) observer.observe(ref);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <Suspense
      fallback={
        <Box
          sx={{
            width: "100vw",
            height: "100vh",
            position: "fixed",
            top: 0,
            left: 0,
            zIndex: 1200,
            bgcolor: "#fff",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <CircularProgress sx={{ color: "#000" }} size={80} thickness={1.5} />
        </Box>
      }
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
        }}
      >
        <Navbar bg_color="#fff" {...props} />
        <MenuDrawer {...props} />
        <SubMenuDrawer {...props} />
        <HomeHeroSlide
          {...{
            ...props,
            slide: {
              videoPath:
                "https://files.automatapp.com/konstantino/assets/legacy.mp4",
            },
          }}
        />
        <Fade in={visibleSections.legacy} timeout={0}>
          <div id="legacy" ref={(el) => (sectionRefs.current.legacy = el)}>
            <Legacy {...props} />
          </div>
        </Fade>
        <Footer {...props} />
      </Box>
    </Suspense>
  );
};

export default ExportDefault;
